import _ from 'lodash';
import React from 'react';
import ReactDOMServer from 'react-dom/server';
import { transform } from 'sucrase';
import typeHandlers from '@skyjs/import/src/handlers/index.js';

// TODO : À décommissioner.

export default function renderJsxDataTemplate(context) {
  return async (jsx, props) => {
    const { db } = context;
    const component = convertJsxFragmentToComponent(jsx);

    return readAsync(db, () => {
      const element = React.createElement(component, props);
      return ReactDOMServer.renderToStaticMarkup(element);
    });
  };
}

const readAsync = (db, callback) => {
  // eslint-disable-next-line no-async-promise-executor
  return new Promise(async (resolve, reject) => {
    let result;

    try {
      while (true) {
        result = callback();

        if (db.isWaitingForData) {
          await Promise.all(_.values(db._promises));
        } else {
          break;
        }
      }

      resolve(result);
    } catch (err) {
      reject(err);
    }
  });
};

export const convertJsxFragmentToComponent = jsx => {
  const content = wrapAsComponent(jsx);
  const options = {
    transforms: ['imports', 'jsx'],
    enableLegacyBabel5ModuleInterop: true,
    disableESTransforms: true
  };
  const es6 = transform(content, options).code;

  const html = value => {
    return React.createElement('div', { dangerouslySetInnerHTML: { __html: value } });
  };

  const dependencies = { lodash: _, react: React, html };
  const _import = id => dependencies[id];
  const component = typeHandlers.js(_import)('', { es6 });

  return component;
};

export const wrapAsComponent = jsxFragment => `
import React from 'react';
import html from 'html';

export default function DynamicComponent(props) {
  return (${jsxFragment});
};
`;
